export default {
	state: {
		userInfo: {
			user_mode: "tourist", // 默认游客态
			token: "",
			accountList: [],
			account: {}
		}
	},
	getters: {
        userInfo: v => v.userInfo,
	},
	mutations: {
		initUser(state, payload) {
			let {userInfo} = payload;
			state.userInfo = {...state.userInfo, ...userInfo};
			state.userInfo.loginStatus = "none";
			state.userInfo.activeStatus = "";
			if (state.userInfo.corporate_flag == false || state.userInfo.corporate_flag == 0) {
				state.userInfo.corporateFlag = 0;
			} else {
				state.userInfo.corporateFlag = 1;
			}
			state.userInfo.secAccId = state.userInfo.account.accountid || "";
			if (state.userInfo.account.sessionid && state.userInfo.account.sessionid !== "") {
				state.userInfo.loginStatus = "security";
			} else if (state.userInfo.token) {
				state.userInfo.loginStatus = "mobile";
			}
			if (state.userInfo.trade_account_list && state.userInfo.trade_account_list.length) {
				state.userInfo.activeStatus = "finished";
			} else if (state.userInfo.open_account_list && state.userInfo.open_account_list.length) {
				state.userInfo.secAccId = state.userInfo.open_account_list[0].accountid;
				// 潜在户
				if (state.userInfo.open_account_list[0].status == "NOTACTIVE")
					state.userInfo.activeStatus = "approving";
				// 开户审核
				if (state.userInfo.open_account_list[0].status == "INTRANSIT") state.userInfo.activeStatus = "latent";
			}
			state.userInfo.hasIdleSecAccount = "false";
			if (state.userInfo.loginStatus == "mobile" && state.userInfo.activeStatus == "finished") {
				state.userInfo.hasIdleSecAccount = "true";
			}
		}
	}
};
